"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const Rail_1 = tslib_1.__importDefault(require("./../Rail"));
const InternalComponents_1 = require("./InternalComponents");
const ServiceNavigationListItem_1 = tslib_1.__importDefault(require("./ServiceNavigationListItem"));
const ServiceNavigationHeader = (0, styles_1.styled)((props) => (react_1.default.createElement(Typography_1.default, { variant: "h6", color: "textPrimary", ...props })))(({ theme }) => ({
    padding: theme.spacing(2),
    textTransform: "capitalize",
}));
const ServiceNavigation = (props) => {
    const { isOpen, items, onMenuButtonClick, header, onClose } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InternalComponents_1.DrawerServiceNavigation, { className: "MneDrawerServiceNavigation", open: isOpen, onClose: onClose },
            react_1.default.createElement(ServiceNavigationHeader, null, header),
            react_1.default.createElement("nav", null,
                react_1.default.createElement(List_1.default, null, items.map((item, idx) => {
                    return react_1.default.createElement(ServiceNavigationListItem_1.default, { key: `service${idx}`, ...item });
                })))),
        react_1.default.createElement(Rail_1.default, { items: items, onMenuButtonClick: onMenuButtonClick })));
};
exports.default = ServiceNavigation;
